import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('addViews');
const type = createActionType('addViews');

export const ADD_DATASETS_TO_PROJECT = apiType('AddDatasetsToProject');
export const ADD_SCHEMA_TO_PROJECT = apiType('AddSchemaToProject');
export const OPEN_ADD_SCHEMA_CONFIRMATION = type('OpenAddSchemaConfirmation');
export const CLOSE_ADD_SCHEMA_CONFIRMATION = type('CloseAddSchemaConfirmation');
export const INITIALIZE_OPEN_ADD_SCHEMA_CONFIRMATION = type('InitializeOpenAddSchemaConfirmation');

export const CLEAR_ERROR = type('ClearError');
